import React ,{useState ,useEffect} from 'react';  
import 'react-day-picker/lib/style.css';
import StepFooter from 'components/presenters/footer/StepFooter'
import DayOfWeekPicker from 'components/presenters/calendar/DayOfWeekPicker';
import MonthRangePicker from 'components/presenters/calendar/MonthRangePicker'; 
import {  formatDate } from 'utils/utils.js';
import {Terminner, Maintit, Checkboxinner, TerminputInner,  Ckboxlist, Ckbox, CkWeek, Ckbox1, Marking, Ckboxlabel, Ckboxlabel1, Ckimg, Ckboxnum, Weekchoice } from './style';

export default function ProjectSettingPeriodStep({state, updateNext,startDate,setStartDate,endDate,setEndDate,periodCheck,setPeriodCheck,dayOfWeek,setDayOfWeek}) {
    
    const [next ,setNext] = useState(false);      
    const [isWeek ,setIsWeek] = useState(false);    
    let disabledDate = [
        {
          before: new Date()
        }
      ];

    useEffect(()=>{

        if(dayOfWeek.length > 0 && !isWeek)
        {
            setIsWeek(true);
        }
    },[]);
    useEffect(()=>{
        if(startDate < formatDate())
        {
            setStartDate((formatDate()))
        }
        if(endDate < formatDate())
        {
            setEndDate((formatDate()))
        }

    },[startDate, endDate]);
    
    const periodCheckChange = (e) => { 
        setIsWeek(true);
        setDayOfWeek([]);
        periodCheckVaildate([]);
        setPeriodCheck(e.target.value); 
    }

    const periodCheckAllWeekend = (e)=>{
        setIsWeek(false);
        setDayOfWeek(['sun', 'mon', 'tue', 'wed','thu', 'fri', 'sat']);
    }

    const periodCheckChangeExceptWeekend = (e) => { 
        setIsWeek(false);
        setDayOfWeek([ 'mon', 'tue', 'wed','thu', 'fri']);
    }

    const checkVailableDate = () =>{
        let currDate = new Date();
        currDate = formatDate(currDate);
        if(startDate && endDate 
            && currDate <= startDate  && currDate <= endDate 
            && (startDate <= endDate))
            return true;
        return false;
    }

    const vaildate =()=>{
        if((new Date(startDate) <= new Date(endDate)) === false){
            return false;
        }
        return true;
    }
    
    const periodCheckVaildate = (list) =>{ 
        return list.length !== 0;
    };

    const vaildateNext = () =>{
        if(periodCheckVaildate(dayOfWeek) && checkVailableDate() && vaildate())
            setNext(true);
        else
            setNext(false);
    }

    useEffect(()=>{
        vaildateNext();
    },[periodCheck,dayOfWeek,endDate,startDate]);

    const handleUpdateDayOfWeek = (updatedDay) =>{
        setDayOfWeek(updatedDay)
    }
    return(
        <Terminner>
            
            <div>
                <Maintit>인증기간</Maintit>
                <TerminputInner>
                    <MonthRangePicker 
                        startDate={startDate}
                        endDate={endDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                        disabledDate={disabledDate}
                    />
                </TerminputInner>
            </div>


            <Checkboxinner>
                <Maintit>인증빈도</Maintit>
                <ul>
                    <Ckboxlist>
                        <Ckbox1 type="radio" id="ck01" name="ckd" value="ck001" checked={isWeek===true} onChange={periodCheckChange}></Ckbox1>
                        <Ckboxlabel1 htmlFor="ck01">
                            <CkWeek>
                                <Ckimg></Ckimg> 
                                주 <Ckboxnum type="number" value={dayOfWeek.length} readOnly /> 일
                            </CkWeek>
                            <Marking className="ck">
                                <Weekchoice>
                                    <DayOfWeekPicker 
                                    selectedItem={dayOfWeek}
                                    updateSelectedItem={handleUpdateDayOfWeek}/>
                                </Weekchoice>
                            </Marking> 
                        </Ckboxlabel1>
                          
                    </Ckboxlist>

                    <Ckboxlist>
                        <Ckbox type="radio" id="ck02" value="ck002" name="ckd" onChange={periodCheckAllWeekend}></Ckbox>
                        <Ckboxlabel htmlFor="ck02"><Ckimg></Ckimg> 매일 (월~일)</Ckboxlabel>
                    </Ckboxlist>
                    <Ckboxlist>
                        <Ckbox type="radio" id="ck03" value="ck003" name="ckd" onChange={periodCheckChangeExceptWeekend}></Ckbox>
                        <Ckboxlabel htmlFor="ck03"><Ckimg></Ckimg> 주말제외 (월~금) </Ckboxlabel>
                    </Ckboxlist>
                </ul>
            </Checkboxinner>
            {
                next?
                <StepFooter
                    text={"3 / 5"}
                    color={"#7f7f7f"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    next={next}
                />
                :
                <StepFooter
                    text={"3 / 5"}
                    color={"#7f7f7f"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    bg={"#d8d8d8"}
                    next={false}
                />
            }
            
        </Terminner>
    );
}

 
